import React, { Component, useState, useEffect, useRef } from "react";
import Button from "@material-ui/core/Button";
import AddCircleIcon from "@material-ui/icons/AddCircle";
// import BrandAdd from "./BrandAdd"
import { Link } from "react-router-dom";
import Backbutton from "../../Backbutton";

//Table
import MUIDataTable from "mui-datatables";

import EditIcon from "@material-ui/icons/Edit";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import LockIcon from "@material-ui/icons/Lock";
import { formatMs, ListItemIcon, Tooltip } from "@material-ui/core";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SweetAlert from "react-bootstrap-sweetalert";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import axios from "axios";
import { connect } from "react-redux";
import { setOrder } from "../../../actions/OrderAction";
import ReactToPrint from 'react-to-print';
import order from "../../../reducers/order";
import Modal from 'react-modal';
import { CircularProgress } from '@material-ui/core';


const Orders = ({ history, server, access_token, setOrder, orders }) => {

  const [temp, setTemp] = useState(orders);
  const [alert, setAlert] = useState(null);
  const [isDetailVisible, setIsDetailVisible] = useState(false)
  const [currentOrder, setCurrentOrder] = useState(null)
  const [loading, setLoading] = useState(false);
  const [changingStatus, setChangingStatus] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [orderStatus, setOrderStatus] = useState('')
  const [currentStatus, setCurrentStatus] = useState('')
  const [commentsEmpty, setCommentsEmpty] = useState(false)  
  const [statusError, setStatusError] = useState(false)  

  const [comment, setComment] = useState('');

  const handleCommentChange = event => {

    setComment(event.target.value);
  };

  const componentRef = useRef();

  const backToOrders = () => {
    setIsDetailVisible(false)
  }

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }


  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      width: '40%',
      transform: 'translate(-50%, -50%)',
    },
  };

  useEffect(() => {
    getAllOrder();
  }, []);

  useEffect(() => {

    if (isDetailVisible == false) {
      getAllOrder();
    }

  }, [isDetailVisible]);

  useEffect(() => {
    setTemp(orders);
  }, [orders]);


  const openOrderDetail = (id) => {

    for (var i = 0; i < orders.length; i++) {

      if (orders[i].id == id) {
        setCurrentOrder(orders[i]);
        setCurrentStatus(orders[i].status)
        setIsDetailVisible(true);
      }
    }
  }


  const changeOrderStatus = (id, comment) => {   

    if (orderStatus == '') {

        setStatusError(true);        
    }else if(comment == ''){

        setCommentsEmpty(true);
    } else { 

      setChangingStatus(true);

      var formData = new FormData();

      formData.append("order_id", id);
      formData.append("status", orderStatus);
      formData.append("comment", comment);

      const requestOptions = {
        method: 'POST',
        body: formData,
      };

      fetch(server + 'api/change-order-status', requestOptions)
        .then(response => response.json())
        .then(data => notifySuccess());
    }
    
  }


  const notifySuccess = () => {

    setCurrentStatus(orderStatus);
    setChangingStatus(false);
    setIsOpen(false);
    setComment('');

    toast('Order status changed', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }


  const getAllOrder = () => {

    setLoading(true);

    const config = {
      headers: { Authorization: `Bearer ${access_token}` },
    };

    axios
      .get(server + "api/order", config)
      .then((response) => {

        var tmpOrders = [];

        for (var i = 0; i < response.data.length; i++) {

          var obj = response.data[i];
          obj.username = response.data[i].user.name + '(#' + response.data[i].user.id + ')';
          obj.placed_at = (new Date(response.data[i].created_at)).toLocaleDateString() +
            ' ' + (new Date(response.data[i].created_at)).toLocaleTimeString();

          obj.order_total = '₹' + response.data[i].order_total.toFixed(2);
          obj.address = response.data[i].user.address + ', ' + response.data[i].user.district
            + ', ' + response.data[i].user.state;

          tmpOrders.push(obj);
        }

        setOrder(tmpOrders);
        setLoading(false)

      })
      .catch((error) => { });
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "username",
      label: "Placed By",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "address",
      label: "Address",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "order_total",
      label: "Order Total",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "placed_at",
      label: "Placed At",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRender: (id, tableMeta, updateValue) => {
          return (
            <>

              <Button
                variant="contained"
                color="primary"
                style={{ backgroundColor: '#F05225' }}
                onClick={() => openOrderDetail(id)}
              >
                View Order
              </Button>
            </>
          );
        },
      },
    },
  ];

  const options = {
    filterType: "multiselect",
    selectableRows: false,
    print: false,
    download: true,
  };

  return (
    <>
      <div className="dashboardMainDivContainer">
        {alert}
        <div className="card m-3 mt-5">

          <div className="titles">Orders</div>
          <div style={{ textAlign: "end" }}>
            <Link className="BtnLinkDist" to="/Brand/Add">

            </Link>
          </div>


          {loading == true ?

            <div style={{ marginTop: "2%" }}>
              <Skeleton height={70} />
              <Skeleton count={15} style={{ marginTop: 15 }} />
            </div>
            :


            <div style={{ marginTop: "2%", }}>

              {!isDetailVisible ?


                <MUIDataTable
                  data={temp}
                  columns={columns}
                  options={options}
                />
                :


                <div style={{ marginBottom: 100 }}>

                  <div className="main-div"
                    ref={componentRef} style={{ display: 'flex', flexDirection: 'column' }}>

                    <h4 style={{ marginLeft: 20, marginTop: 20 }}>Order #0000{currentOrder.id}</h4>
                    <hr />

                    <table className="orderReview"
                      border="0"
                      style={{
                        width: '100%',
                        border: '0 px solid grey', borderCollapse: 'collapse', marginTop: 20,
                        paddingRight: 10, paddingLeft: 10
                      }}>

                      <thead>

                        <tr>
                          <th>#</th>
                          <th>Category</th>
                          <th>Brand</th>
                          <th>Product</th>
                          <th>Fitment For</th>
                          <th>Color</th>
                          <th>Unit Price</th>
                          <th>Quantity</th>
                          <th></th>
                        </tr>

                      </thead>

                      <tbody>

                        {currentOrder && currentOrder.order_items.map((item, index) => (

                          <tr>
                            <td style={{ textAlign: 'center', padding: 20 }}>{index + 1}</td>
                            <td style={{ textAlign: 'center', padding: 20 }}>{item.category}</td>
                            <td style={{ textAlign: 'center', padding: 20 }}>{item.brand}</td>
                            <td style={{ textAlign: 'center', padding: 20 }}>{item.product ? item.product.name : ''}</td>
                            <td style={{ textAlign: 'center', padding: 20 }}>{item.fitment_for !== 'null' && item.fitment_for}</td>
                            <td style={{ textAlign: 'center', padding: 20 }}>{item.color}</td>
                            <td style={{ textAlign: 'center', padding: 20 }}>₹{item.unit_price}</td>
                            <td style={{ textAlign: 'center', padding: 20 }}>{item.quantity}</td>

                          </tr>
                        ))}

                      </tbody>

                    </table>

                    <span style={{ marginTop: 50, marginLeft: 15 }}><b>Order Comments: </b>{currentOrder.order_comments}</span><br /><br />
                    <span style={{ marginTop: 10, marginLeft: 15 }}><b>Mode of Delivery: </b>{currentOrder.mode_of_delivery}</span>





                    <div style={{ marginTop: 30, marginLeft: 15 }}>

                      <p><b>Order Status:</b> {currentStatus}</p>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={openModal}
                        style={{
                          width: '20%', height: 35, marginRight: '1%', paddingTop: 10, backgroundColor: '#4169E1',
                          float: 'left', alignSelf: 'flex-start'
                        }}>
                        Change Order Status
                      </Button>




                    </div>


                    <hr />
                    <div style={{ marginTop: 30, marginLeft: 15 }}>

                      <h3 style={{ marginBottom: 25 }}>Order Timeline</h3>

                      <div style={{ backgroundColor: '#E8E8E8', padding: 10, borderRadius: 5, marginTop: 20 }}>
                        <p style={{ fontWeight: 'bold' }}>Order was placed</p>
                        <p>{new Date(currentOrder.created_at).toDateString()}</p>
                      </div>

                      {currentOrder.order_updates.reverse().map((orderUpdate) => (

                        <div style={{ backgroundColor: '#E8E8E8', padding: 10, borderRadius: 5, marginTop: 20 }}>
                          <p style={{ fontWeight: 'bold' }}>Order status was changed from {orderUpdate.previous_status} to {orderUpdate.changed_status}</p>
                          <p>{new Date(orderUpdate.created_at).toDateString()}</p>
                          {orderUpdate.comment &&
                            <p><b>Comment: </b>{orderUpdate.comment}</p>
                          }
                        </div>

                      ))}

                    </div>

                    <div style={{ float: 'right', marginBottom: 20, marginRight: 50, marginTop: 50 }}>

                      <h3 style={{ textAlign: 'right' }}>
                        Order Total : {currentOrder.order_total}</h3>

                    </div>
                  </div>

                  <ReactToPrint
                    trigger={() => <button className="btn9"
                      documentTitle={'Order' + '#000' + currentOrder.id + '.pdf'}
                      pageStyle={pageStyle}
                      style={{
                        width: '20%', marginRight: '1%', height: 35,
                        borderRadius: 4,
                        float: 'right', alignSelf: 'flex-end', backgroundColor: '#F05225',
                        border: 'none', fontWeight: 500, color: 'white', fontSize: '0.875rem'
                      }}>
                      PRINT ORDER</button>}
                    content={() => componentRef.current}
                  />


                  <Button
                    variant="contained"
                    color="primary"
                    onClick={backToOrders}
                    style={{
                      width: '20%', height: 35, marginRight: '1%', paddingTop: 10,
                      float: 'right', alignSelf: 'flex-end'
                    }}>
                    Back to Orders
                  </Button>

                </div>
              }

            </div>
          }
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >


        {currentOrder &&
          <div style={{ marginTop: 30, marginLeft: 15, display: 'flex', flexDirection: 'column' }}>

            <label>Order Status</label><br />
            <select className="form-control"
              defaultValue={currentOrder.status}
              onChange={(event) => setOrderStatus(event.target.value)}>

              <option value="Received">Received</option>
              <option value="In Process">In Process</option>
              <option value="Partially Dispatched">Partially Dispatched</option>
              <option value="Fully Dispatched">Fully Dispatched</option>
            </select>

            {statusError &&
                <p style={{color:'red'}}>Please change the status before submitting</p>
            }

            <textarea className="form-control"
              style={{ marginTop: 30, height: 100 }}
              name="comment"
              placeholder="Enter comments here"
              onChange={handleCommentChange}
              id="comment">{comment}
            </textarea>

            {commentsEmpty &&
                <p style={{color:'red'}}>Comment is mandatory while changing order status</p>
            }


            <Button
              variant="contained"
              color="primary"
              onClick={(event) => changeOrderStatus(currentOrder.id, comment)}
              style={{
                width: '20%', height: 35, marginRight: '1%', paddingTop: 10, marginTop: 10, backgroundColor: '#4169E1',
                float: 'left', alignSelf: 'flex-start'
              }}>

              {changingStatus ? <CircularProgress style={{ color: 'white', width: 20 }} /> : "SUBMIT"}
            </Button>
          </div>
        }

      </Modal>

    </>
  );
};

const mapStateToProps = (state) => ({
  server: state.auth.server,
  access_token: state.auth.access_token,
  orders: state.order,
});

const pageStyle = `
  @page {
    size: 148mm 210mm;
    padding:5px;
  }

  @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }
`;

export default connect(mapStateToProps, { setOrder })(Orders);
